const ServiceIconConfig = {
  20: {
    borderRadius: 3,
    iconSize: 14,
    spacing: 5
  },
  30: {
    borderRadius: 3,
    iconSize: 20,
    spacing: 5
  },
  40: {
    borderRadius: 5,
    iconSize: 30,
    spacing: 5
  },
  60: {
    borderRadius: 8,
    iconSize: 40,
    spacing: 10
  },
  80: {
    borderRadius: 10,
    iconSize: 60,
    spacing: 20
  },
  120: {
    borderRadius: 15,
    iconSize: 90,
    spacing: 30
  },
  150: {
    borderRadius: 18,
    iconSize: 110,
    spacing: 40
  }
};
const PDLStyleMap = {
  20: {
    width: "--zds-size-small",
    borderRadius: "--zds-radius-small",
    iconSize: "--pdl-small-icon-size"
    // this variable is defined in ServiceIconShell as a workaround
  },
  30: {
    width: "--zds-size-small",
    borderRadius: "--zds-radius-small",
    iconSize: "--pdl-small-icon-size"
    // this variable is defined in ServiceIconShell as a workaround
  },
  40: {
    width: "--zds-size-medium",
    borderRadius: "--zds-radius-medium",
    iconSize: "--zds-size-small"
  },
  60: {
    width: "--zds-size-large",
    borderRadius: "--zds-radius-medium",
    iconSize: "--zds-size-medium"
  },
  80: {
    width: "--zds-size-large",
    borderRadius: "--zds-radius-medium",
    iconSize: "--zds-size-medium"
  },
  120: {
    width: "--zds-size-large",
    borderRadius: "--zds-radius-medium",
    iconSize: "--zds-size-medium"
  },
  150: {
    width: "--zds-size-large",
    borderRadius: "--zds-radius-medium",
    iconSize: "--zds-size-medium"
  }
};

export { PDLStyleMap, ServiceIconConfig };
//# sourceMappingURL=constants.es.js.map
